import React from 'react';
import styled from 'styled-components';

const LogoWrapper = styled.img`
    width: 100%;
`

interface IProps {
    src: string;
}

const Logo = (props: IProps) => {
    return(
        <LogoWrapper src={props.src} />
    )
}

export default Logo;